// Pilot des Homelab-Protokolls auf der Startseite: die Feinstaubwerte der
// ESPHome-Karte kommen aus `feinstaub.<node>.luft` statt aus dem MQTT-Zustand.
// Die Karte fällt auf den bisherigen Wert zurück, solange kein (frischer)
// Protokoll-Stand da ist (docs/protokoll.md, „Browser (Phase 4)").

import { abonniere, instanzStand, instanzZeit } from "./client.svelte";
import { feinstaubInstanz, mitProtokollwerten, protokollZustaende, type KartenEntitaet } from "./feinstaub-logik";
import { TOPICS } from "./schema.gen";

const FAMILIE = TOPICS.find((t) => t.name === "feinstaub.luft");

/** Alle Feinstaub-Boards abonnieren (`feinstaub.*.luft`, Rate normal); Rückgabe
 *  = abmelden. Nur aufrufen, solange die Seite zu sehen ist. */
export function abonniereFeinstaub(): () => void {
  return abonniere("feinstaub.*.luft", { rate: "normal" }, {});
}

/** Entitäten eines Geräts mit den Protokollwerten (reaktiv). `haDeviceId` ist
 *  die Quell-Adresse des Geräts (`feinstaub:<node>`); `jetztMs` liefert die Uhr
 *  des Dienstes, an der der Verfall gemessen wird, und wird NUR gelesen, wenn
 *  das Gerät eine Feinstaub-Instanz mit Stand hat -- alle anderen Karten
 *  hängen so nicht an der (tickenden) Uhr. Keine Feinstaub-Instanz oder kein
 *  frischer Stand → die Entitäten unverändert (dasselbe Objekt). */
export function feinstaubEntitaeten<E extends KartenEntitaet>(haDeviceId: string, entitaeten: E[], jetztMs: () => number): E[] {
  const instanz = feinstaubInstanz(haDeviceId);
  if (!instanz || !FAMILIE) return entitaeten;
  const stand = instanzStand(instanz);
  if (!stand) return entitaeten;
  const zustaende = protokollZustaende(stand, instanzZeit(instanz), jetztMs(), FAMILIE.felder, FAMILIE.lebenszeichen_ms);
  return mitProtokollwerten(entitaeten, zustaende);
}
